import { Clear, Tune } from "@mui/icons-material";
import { Button, ClickAwayListener, Divider, Fade, Paper, Popper, Stack, Typography } from "@mui/material";
import { useMemo, useState } from "react";
import { ORDER_SOURCE_TYPE } from "src/constant";
import { PERMISSIONS, useRoleCheck } from "src/hooks/permission/permission";
import useGetDataFromSelect from "src/hooks/useGetDataFromSelect";
import useWareHouseList from "src/hooks/warehouse/useWareHouseList";

const FILTER_KEYS = ["role", "warehouse"];

/**
 * Bộ lọc dành riêng cho quản lý nhân viên.
 */
export default function EmployeeFilter({ setParamsQuery, paramsQuery }) {
  const permissionCheck = useRoleCheck();
  const { data: roleList } = useGetDataFromSelect("/api/v1/roles", { limit: 100, skip: 0 });
  const { data: warehouseList } = useWareHouseList({ limit: 100, skip: 0 });

  const [popperProps, setPopperProps] = useState({
    open: false,
    anchorEl: null,
    placement: "bottom-end",
  });

  const handlePickOptionSearch = ({ name, value }) => {
    setParamsQuery({
      ...paramsQuery,
      [name]: value === ORDER_SOURCE_TYPE.All ? undefined : value,
    });
  };

  const isTatCaActiveForFilterGroup = (groupName) => {
    return [ORDER_SOURCE_TYPE.All, undefined]?.includes(paramsQuery?.[groupName]);
  };

  const filterList = [
    {
      id: "role",
      name: "role",
      tatCaKey: "role",
      title: "Vai trò",
      data: Array.isArray(roleList?.data) ? roleList.data : [],
    },
    // {
    //   id: "user-employee-warehouse",
    //   name: "warehouse",
    //   tatCaKey: "warehouse",
    //   title: "Kho",
    //   data: Array.isArray(warehouseList?.data) ? warehouseList.data : [],
    //   display: permissionCheck([PERMISSIONS.VIEW_SYSTEM_ALL, PERMISSIONS.VIEW_SYSTEM_OWN]),
    // },
  ];

  const handleSetPop = (placement) => (event) => {
    setPopperProps({
      open: !popperProps.open,
      anchorEl: event.currentTarget,
      placement,
    });
  };

  const handleClosePopper = () => {
    setPopperProps((prev) => ({ ...prev, open: false }));
  };

  const hasActiveFilters = useMemo(() => {
    return FILTER_KEYS.some((k) => {
      const val = paramsQuery?.[k];
      return val !== undefined && val !== null && val !== "";
    });
  }, [paramsQuery]);

  const handleClearFilters = () => {
    setParamsQuery((prev) => {
      const next = { ...(prev ?? {}) };
      FILTER_KEYS.forEach((key) => {
        delete next[key];
      });
      return next;
    });
  };

  return (
    <ClickAwayListener onClickAway={handleClosePopper}>
      <Stack sx={{ display: "inline-block" }}>
        <Button
          size="small"
          variant="outlined"
          sx={{ height: "100%", maxHeight: "36.5px" }}
          startIcon={<Tune />}
          onClick={handleSetPop("bottom-end")}
        >
          Lọc
        </Button>
        <Popper
          disablePortal
          sx={{
            zIndex: 1200,
            maxWidth: "900px",
            width: "90%",
            maxHeight: "330px",
            height: "auto",
            overflow: "auto",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          }}
          open={popperProps.open}
          anchorEl={popperProps.anchorEl}
          placement={popperProps.placement}
          transition
        >
          {({ TransitionProps }) => (
            <Fade
              {...TransitionProps}
              timeout={350}
            >
              <Paper sx={{ p: "12px", display: "flex", flexDirection: "column" }}>
                <Stack
                  direction="row"
                  justifyContent="flex-end"
                  sx={{ pb: 1, mb: 1, borderBottom: "1px solid var(--light-grey)" }}
                >
                  <Button
                    size="small"
                    variant="outlined"
                    color="inherit"
                    startIcon={<Clear />}
                    disabled={!hasActiveFilters}
                    onClick={handleClearFilters}
                    sx={{ fontSize: "12px" }}
                  >
                    Xóa bộ lọc
                  </Button>
                </Stack>
                {filterList.map((v) => {
                  return (
                    (v?.display || v?.display === undefined) && (
                      <Stack
                        direction="column"
                        key={v.id}
                        spacing={1}
                        mb={1.5}
                        pd={1.5}
                      >
                        <Typography sx={{ fontWeight: "bold", fontSize: "12px" }}>{v.title}</Typography>
                        <Stack
                          direction="row"
                          gap={1}
                          flexWrap="wrap"
                        >
                          <Button
                            onClick={() =>
                              handlePickOptionSearch({
                                name: v.tatCaKey,
                                value: ORDER_SOURCE_TYPE.All,
                              })
                            }
                            sx={{
                              border: isTatCaActiveForFilterGroup(v.tatCaKey) ? "1px solid var(--confirm-txt)" : "1px solid var(--light-grey)",
                              color: isTatCaActiveForFilterGroup(v.tatCaKey) ? "var(--confirm-txt)" : "var(--black)",
                              display: "inline",
                              borderRadius: "4px",
                              fontSize: "12px",
                            }}
                          >
                            Tất cả
                          </Button>
                          {v?.data?.map((val) => (
                            <Button
                              key={val?._id}
                              onClick={() =>
                                handlePickOptionSearch({
                                  name: v.name,
                                  value: val?._id,
                                })
                              }
                              sx={{
                                border: paramsQuery?.[v.name] === val?._id ? "1px solid var(--confirm-txt)" : "1px solid var(--light-grey)",
                                color: paramsQuery?.[v.name] === val?._id ? "var(--confirm-txt)" : "var(--black)",
                                display: "inline",
                                p: "6px 12px !important",
                                borderRadius: "4px",
                                fontSize: "12px",
                              }}
                            >
                              {val?.name}
                            </Button>
                          ))}
                        </Stack>
                        <Divider sx={{ color: "var(--light-grey)" }} />
                      </Stack>
                    )
                  );
                })}
              </Paper>
            </Fade>
          )}
        </Popper>
      </Stack>
    </ClickAwayListener>
  );
}
